// extracted by mini-css-extract-plugin
module.exports = {"moment-tooltip":"tooltip_moment-tooltip__dB0tw"};